import { Object3D } from "three"

export const useScripts = (scripts: ((obj: Object3D) => void)[]) => {
  return (obj: Object3D) => {
    scripts.forEach(s => s(obj))
  }
}
